import { render, staticRenderFns } from "./TownNews.vue?vue&type=template&id=b51255be&"
import script from "./TownNews.vue?vue&type=script&lang=ts&"
export * from "./TownNews.vue?vue&type=script&lang=ts&"
import style0 from "./TownNews.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports